exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fuel_surcharge .font-size-16 {\n  font-size: 16px; }\n\n.fuel_surcharge .image-height-50 {\n  height: 50px; }\n\n.fuel_surcharge .atm-codes-location {\n  font-size: 16px;\n  margin-bottom: 2px; }\n\n.fuel_surcharge .atm-edit-height {\n  position: absolute;\n  right: 10px;\n  height: 20px; }\n\n.fuel_surcharge .text-align-right {\n  text-align: right; }\n\n.fuel_surcharge .atm-code-box {\n  width: 100px !important;\n  text-align: center; }\n\n.fuel_surcharge .display-inline-block {\n  display: inline-block; }\n\n.fuel_surcharge .margin-top-05 {\n  margin-top: 5px; }\n\n.fuel_surcharge .msg-font-size {\n  font-size: 15px; }\n\n.fuel_surcharge .badge-custome-success {\n  background-color: #5CB85C !important; }\n\n.fuel_surcharge .alert-pad-10 {\n  padding: 10px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_billing/components/fuel_surcharges/fuel_surcharges.scss
// module id = 1122
// module chunks = 1